import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1600px;
    margin: auto;
    padding: 0 20px;
    margin-bottom: 2rem;

    @media (max-width: 1024px) {
        max-width: 95%;
    }

    @media (max-width: 768px) {
        padding: 0 10px;
        max-width: 100%;
    }
`

export const ContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    max-width: 1200px;
    margin: auto;

    @media (max-width: 768px) {
        max-width: 100%;
        padding: 0 10px;
    }
`
